<form [formGroup]="formGroup">
  <div class="{{ viewMode }}">
    <div class="repair-limit-section-header justify-self-start w-full mb-3">
      <p class="p-0 mt-3 mb-3" id="repair-limit-header-{{ index }}">
        {{
          this.index === 0
            ? this.translationService.translate('repairLimitsHeader')
            : this.translationService.translate('repairLimitsHeader') + ' ' + (this.index + 1)
        }}
      </p>
      <mat-divider></mat-divider>
    </div>

    <div class="grid grid-rows-1">
      <app-action-details
        id="repairLimitsActionDetails"
        [limitTranslationKey]="'totalRepairs'"
        [limitFormControlName]="'totalRepairs'"
        [id]="'repairLimit' + index"
        [limit]="limit.totalRepairLimits.totalRepairs"
        [formGroup]="formGroup"
        [editMode]="editMode"
        [isDefault]="isDefault"
      />
    </div>

    <div class="section-header justify-self-start w-full mb-3">
      <p class="p-0 mt-3 mb-3" id="repair-limit-nailRepair-header-{{ index }}">{{ translationService.translate('nailRepairHeader') }}</p>
    </div>

    <div class="grid grid-rows-1">
      <div class="grid grid-cols-7 gap-10 justify-self-start w-full">
        <div class="w-full">
          <mat-form-field class="w-full" id="repair-limit-totalNail-{{ index }}">
            <mat-label
              [ngClass]="{ 'custom-label': true, 'custom-label-error': formGroup.get('totalNail').hasError('repairLimitValidator') }"
              >{{ translationService.translate('totalNailText') }}</mat-label
            >
            <input
              id="repair-limit-totalNailInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.totalRepairLimits.nailRepairs }}"
              [readonly]="!editMode"
              formControlName="totalNail"
              (input)="checkValue($event, 'totalNail')"
            />
            @if (formGroup.get('totalNail').hasError('repairLimitValidator')) {
            <mat-error class="custom-error" id="repair-limit-totalNailError-{{ index }}">{{
              translationService.translate('exceedsTotalRepairErrorText')
            }}</mat-error>
            } @if (editMode && formGroup.get('totalNail').value > mrtToValidate.nailRnail) {
            <mat-hint id="repair-limit-totalNailWarning-{{ index }}" class="mic-info">{{
              translationService.translate('exceedWarningText')
            }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field class="w-full" id="repair-limit-totalRNailCrown-{{ index }}">
            <mat-label
              [ngClass]="{ 'custom-label': true, 'custom-label-error': formGroup.get('totalRnailCrown').hasError('repairLimitValidator') }"
              >{{ translationService.translate('totalRNailCrownText') }}</mat-label
            >
            <input
              id="repair-limit-totalRNailCrownInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.totalRepairLimits.rnailCrownRepairs }}"
              [readonly]="!editMode"
              formControlName="totalRnailCrown"
              (input)="checkValue($event, 'totalRnailCrown')"
            />
            @if (formGroup.get('totalRnailCrown').hasError('repairLimitValidator')) {
            <mat-error class="custom-error" id="repair-limit-totalRNailCrownError-{{ index }}">{{
              translationService.translate('exceedsTotalRepairErrorText')
            }}</mat-error>
            } @if (editMode && formGroup.get('totalRnailCrown').value > mrtToValidate.nailRnail) {
            <mat-hint id="repair-limit-totalRNailCrownWarning-{{ index }}" class="mic-info">{{
              translationService.translate('exceedWarningText')
            }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field class="w-full" id="repair-limit-totalRNailShoulder-{{ index }}">
            <mat-label
              [ngClass]="{
                'custom-label': true,
                'custom-label-error': formGroup.get('totalRnailShoulder').hasError('repairLimitValidator')
              }"
              >{{ translationService.translate('totalRNailShoulderText') }}</mat-label
            >
            <input
              id="repair-limit-totalRNailShoulderInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.totalRepairLimits.rnailShoulder.repairs }}"
              [readonly]="!editMode"
              formControlName="totalRnailShoulder"
              (input)="checkValue($event, 'totalRnailShoulder')"
            />
            @if (formGroup.get('totalRnailShoulder').hasError('repairLimitValidator')) {
            <mat-error class="custom-error" id="repair-limit-totalRnailShoulderError-{{ index }}">{{
              translationService.translate('exceedsTotalRepairErrorText')
            }}</mat-error>
            } @if (editMode && formGroup.get('totalRnailShoulder').value > mrtToValidate.nailRnail) {
            <mat-hint id="repair-limit-totalRnailShoulderWarning-{{ index }}" class="mic-info">{{
              translationService.translate('exceedWarningText')
            }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <app-spec-dropdown
            [editMode]="editMode"
            [id]="'repair-limit-rNailShoulderSize-' + index"
            [formGroup]="formGroup"
            [controlName]="'rNailShoulderSize'"
            [options]="rNailShoulderSizes"
            [label]="translationService.translate('rNailShoulderSizeText')"
          />
        </div>
      </div>
    </div>

    <div class="section-header justify-self-start w-full mb-3">
      <p class="p-0 mt-3 mb-3" id="repair-limit-sectionRepair-header-{{ index }}">
        {{ translationService.translate('sectionRepairHeader') }}
      </p>
    </div>

    <div class="grid grid-rows-1">
      <div class="grid grid-cols-7 gap-10 justify-self-start w-full">
        <div class="w-full">
          <mat-form-field class="w-full" id="repair-limit-totalSection-{{ index }}">
            <mat-label
              [ngClass]="{ 'custom-label': true, 'custom-label-error': formGroup.get('totalSection').hasError('repairLimitValidator') }"
              >{{ translationService.translate('totalSectionText') }}</mat-label
            >
            <input
              id="repair-limit-totalSectionInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.totalRepairLimits.section.repairs }}"
              [readonly]="!editMode"
              formControlName="totalSection"
              (input)="checkValue($event, 'totalSection')"
            />
            @if (formGroup.get('totalSection').hasError('repairLimitValidator')) {
            <mat-error class="custom-error" id="repair-limit-totalSectionError-{{ index }}">{{
              translationService.translate('exceedsTotalRepairErrorText')
            }}</mat-error>
            } @if (editMode && formGroup.get('totalSection').value > mrtToValidate.totalSection) {
            <mat-hint id="repair-limit-totalSectionWarning-{{ index }}" class="mic-info">{{
              translationService.translate('exceedWarningText')
            }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field class="w-full" id="repair-limit-totalCrownSection-{{ index }}">
            <mat-label
              [ngClass]="{
                'custom-label': true,
                'custom-label-error': formGroup.get('totalCrownSection').hasError('repairLimitValidator')
              }"
              >{{ translationService.translate('totalCrownSectionText') }}</mat-label
            >
            <input
              id="repair-limit-totalCrownSectionInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.totalRepairLimits.section.crown.count }}"
              [readonly]="!editMode"
              formControlName="totalCrownSection"
              (input)="checkValue($event, 'totalCrownSection')"
            />
            @if (formGroup.get('totalCrownSection').hasError('repairLimitValidator')) {
            <mat-error class="custom-error" id="repair-limit-totalCrownSectionError-{{ index }}">{{
              translationService.translate('exceedsTotalSectionErrorText')
            }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <app-spec-dropdown
            [editMode]="editMode"
            [id]="'repair-limit-maxCrownSize-' + index"
            [formGroup]="formGroup"
            [controlName]="'maxCrownSize'"
            [options]="maxCrownSizes"
            [label]="translationService.translate('maxCrownSizeText')"
          />
        </div>

        <div class="w-full">
          <mat-form-field class="w-full" id="repair-limit-totalShoulderSection-{{ index }}">
            <mat-label
              [ngClass]="{
                'custom-label': true,
                'custom-label-error': formGroup.get('totalShoulderSection').hasError('repairLimitValidator')
              }"
              >{{ translationService.translate('totalShoulderSectionText') }}</mat-label
            >
            <input
              id="repair-limit-totalShoulderSectionInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.totalRepairLimits.section.shoulder.count }}"
              [readonly]="!editMode"
              formControlName="totalShoulderSection"
              (input)="checkValue($event, 'totalShoulderSection')"
            />
            @if (formGroup.get('totalShoulderSection').hasError('repairLimitValidator')) {
            <mat-error class="custom-error" id="repair-limit-totalShoulderSectionError-{{ index }}">{{
              translationService.translate('exceedsTotalSectionErrorText')
            }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <app-spec-dropdown
            [editMode]="editMode"
            [id]="'repair-limit-maxShoulderSize-' + index"
            [formGroup]="formGroup"
            [controlName]="'maxShoulderSize'"
            [options]="maxShoulderSizes"
            [label]="translationService.translate('maxShoulderSizeText')"
          />
        </div>

        <div class="w-full">
          <mat-form-field class="w-full" id="repair-limit-totalSidewallSection-{{ index }}">
            <mat-label
              [ngClass]="{
                'custom-label': true,
                'custom-label-error': formGroup.get('totalSidewallSection').hasError('repairLimitValidator')
              }"
              >{{ translationService.translate('totalSidewallSectionText') }}</mat-label
            >
            <input
              id="repair-limit-totalSidewallSectionInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.totalRepairLimits.section.sidewall.count }}"
              [readonly]="!editMode"
              formControlName="totalSidewallSection"
              (input)="checkValue($event, 'totalSidewallSection')"
            />
            @if (formGroup.get('totalSidewallSection').hasError('repairLimitValidator')) {
            <mat-error class="custom-error" id="repair-limit-totalSidewallSectionError-{{ index }}">{{
              translationService.translate('exceedsTotalSectionErrorText')
            }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <app-spec-dropdown
            [editMode]="editMode"
            [id]="'repair-limit-maxSidewallSize-' + index"
            [formGroup]="formGroup"
            [controlName]="'maxSidewallSize'"
            [options]="maxSidewallSizes"
            [label]="translationService.translate('maxSidewallSizeText')"
          />
        </div>
      </div>
    </div>

    <div class="section-header justify-self-start w-full mb-3">
      <p class="p-0 mt-3 mb-3" id="repair-limit-otherRepair-header-{{ index }}">{{ translationService.translate('otherRepairHeader') }}</p>
    </div>

    <div class="grid grid-rows-1">
      <div class="grid grid-cols-7 gap-10 justify-self-start w-full">
        <div class="w-full">
          <mat-form-field class="w-full" id="other-repair-spot-{{ index }}">
            <mat-label class="custom-label">{{ translationService.translate('spotText') }}</mat-label>
            <input
              id="other-repair-spotInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.otherRepairLimits.spot }}"
              [readonly]="!editMode"
              formControlName="spot"
              (input)="checkValue($event, 'spot')"
            />
            @if (editMode && formGroup.get('spot').value > mrtToValidate.spot) {
            <mat-hint id="repair-limit-spotWarning-{{ index }}" class="mic-info">{{
              translationService.translate('exceedWarningText')
            }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field class="w-full" id="other-repair-bead-{{ index }}">
            <mat-label class="custom-label">{{ translationService.translate('beadText') }}</mat-label>
            <input
              id="other-repair-beadInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.otherRepairLimits.bead }}"
              [readonly]="!editMode"
              formControlName="bead"
              (input)="checkValue($event, 'bead')"
            />
            @if (editMode && formGroup.get('bead').value > mrtToValidate.bead) {
            <mat-hint id="repair-limit-beadWarning-{{ index }}" class="mic-info">{{
              translationService.translate('exceedWarningText')
            }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field class="w-full" id="other-repair-liner-{{ index }}">
            <mat-label class="custom-label">{{ translationService.translate('linerText') }}</mat-label>
            <input
              id="other-repair-linerInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.otherRepairLimits.liner }}"
              [readonly]="!editMode"
              formControlName="liner"
              (input)="checkValue($event, 'liner')"
            />
            @if (editMode && formGroup.get('liner').value > mrtToValidate.liner) {
            <mat-hint id="repair-limit-linerWarning-{{ index }}" class="mic-info">{{
              translationService.translate('exceedWarningText')
            }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-form-field class="w-full" id="other-repair-brakeSkid-{{ index }}">
            <mat-label class="custom-label">{{ translationService.translate('brakeSkidText') }}</mat-label>
            <input
              id="other-repair-brakeSkidInput-{{ index }}"
              matInput
              type="number"
              min="0"
              (keydown)="enforceNumberField({ event: $event })"
              value="{{ limit.otherRepairLimits.brake }}"
              [readonly]="!editMode"
              formControlName="brakeSkid"
              (input)="checkValue($event, 'brakeSkid')"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
